import { useIonPopover } from "@ionic/react";
import { useCallback, useRef } from "react";
import { FormattedMessage } from "react-intl";

import styles from "@components/TableHeaderExtraInfo.module.css";
import BodyCopy from "@components/typography/BodyCopy";
import ButtonLink from "@components/typography/ButtonLink";
import SecondaryButtonIcon from "@components/typography/icons/SecondaryButtonIcon";

type Props = {
  descriptionKey?: string;
  linkKey: string;
  onOpen: () => void;
  titleKey: string;
};

const TableHeaderExtraInfo = ({ descriptionKey, linkKey, onOpen, titleKey }: Props) => {
  const popoverContent = (
    <div className="ion-padding">
      <p>
        <BodyCopy bold>
          <FormattedMessage id={titleKey} />
        </BodyCopy>
      </p>
      {descriptionKey && (
        <p>
          <BodyCopy>
            <FormattedMessage id={descriptionKey} />
          </BodyCopy>
        </p>
      )}
      <p>
        <ButtonLink onClick={onOpen}>
          <FormattedMessage id={linkKey} />
        </ButtonLink>
      </p>
    </div>
  );

  const [presentPopover] = useIonPopover(<div>{popoverContent}</div>);

  const popoverTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handlePopoverEnter = useCallback(() => {
    popoverTimeoutRef.current = setTimeout(() => {
      presentPopover();
    }, 300);
  }, [presentPopover]);

  const handlePopoverLeave = useCallback(() => {
    if (popoverTimeoutRef.current) {
      clearTimeout(popoverTimeoutRef.current);
    }
  }, []);

  return (
    <div className={styles.weightInfoIcon} onMouseEnter={handlePopoverEnter} onMouseLeave={handlePopoverLeave}>
      <SecondaryButtonIcon icon="infoCircle" />
    </div>
  );
};

export default TableHeaderExtraInfo;
